<script>
    import { createEventDispatcher } from "svelte";

    export let title = "";

    const dispatch = createEventDispatcher();
</script>

<div class="header">
    <h1 class="title">
        {title}
    </h1>

    <button class="close-panel-button" on:click={() => dispatch("close")}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
            />
        </svg>
    </button>
</div>

<style>
    @import "../../../main.css";

    .header {
        @apply reset relative flex flex-shrink-0 flex-row border-0 border-b border-solid border-gray-200 bg-white shadow-sm !important;
    }

    .title {
        @apply reset px-4 py-2 text-base font-light !important;
    }

    .close-panel-button {
        @apply reset ml-auto flex cursor-pointer items-center px-4 py-2 !important;
    }

    .close-panel-button svg {
        @apply reset h-4 w-4 text-inherit !important;
    }
</style>
